module.exports = __webpack_public_path__ + "static/media/quoteBorderLeft.2ccdee80.svg";